import theme from '@ifca-root/react-component/src/assets/theme'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import SwitchBar from '@ifca-root/react-component/src/components/SpecialBar/SwitchBar'
import { useMediaQuery } from '@material-ui/core'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import {
  useGetArScheduledBillingbyStatusListingLazyQuery,
  useGetGenerateScheduledBillingListingLazyQuery,
  useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { ARScheduledBillingEntryList } from './ARScheduledBillingList/ARScheduledBillingEntryList'
import { ARScheduledBillingPostingList } from './ARScheduledBillingList/ARScheduledBillingPostingList'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ARGenerateScheduledBillingEntryList } from './ARGenerateScheduledBillingList/ARGenerateScheduledBillingEntryList'

export const ARGenerateScheduledBillingMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const approvalStatusEnum = [
    { name: 'Schedule', ID: 'SCHEDULED' },
    { name: 'Billed', ID: 'BILLED' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [postIDs, setPostIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'SCHEDULED'
  )

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  // for Sales Order Billing Schedule
  const [
    loadGenerateScheduledBilling,
    {
      loading: getGenerateScheduledBillingListingLoading,
      data: { getGenerateScheduledBillingListing } = {
        getGenerateScheduledBillingListing: [],
      },
    },
  ] = useGetGenerateScheduledBillingListingLazyQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ getGenerateScheduledBillingListing }) => {
      if (getGenerateScheduledBillingListing?.Data?.length > 0) {
        setOriginalListing([
          ...filteredList,
          ...getGenerateScheduledBillingListing?.Data,
        ])
      }
    },
  })

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
  })

  /* ------------------------------------------ */
  /*                    VARIABLE                */
  /* ------------------------------------------ */
  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()

  const hasChanges = () => {
    if (postIDs?.size === 0) return false
    else return true
  }

  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadGenerateScheduledBilling({
          variables: {
            CompanyID,
            isBilled: !!(listStatus === 'BILLED'),
            take: 30,
            skip: 0,
            searchValue: change,
          },
        })
      }, 1000)
    )
  }

  useEffect(() => {
    setOriginalListing([])
    loadGenerateScheduledBilling({
      variables: {
        CompanyID,
        isBilled: !!(listStatus === 'BILLED'),
        take: 30,
        skip: 0,
        ...(getSearch?.name && { searchValue: getSearch?.name }),
      },
    })
  }, [listStatus])

  return (
    <>
      {UserLoading && <Loading />}
      {getGenerateScheduledBillingListingLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true && listStatus === 'SUBMIT'
            ? setOpenExitConf(true)
            : history.push(`/account-receivable/${CompanyID}`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Receivable' },
          { name: 'Generate Schedule Billing', current: true },
        ]}
      />
      <SwitchBar
        options={approvalStatusEnum}
        setOptionID={setListStatus}
        borderRadius="4px"
        defaultOption={approvalStatusEnum
          ?.map(opt => opt?.ID)
          .indexOf(listStatus ?? 'SCHEDULED')}
        searchFilter={getSearch}
      />
      <div
        className="search-filter with-dropdown-filter"
        style={{ marginTop: isDesktop ? '-64px' : '0px', marginBottom: '-8px' }}
      >
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            localStorage.setItem(
              'searchFilter',
              JSON.stringify({
                option: listStatus ?? 'SCHEDULED',
                name: e?.target?.value,
              })
            )
            changeDelay(e?.target?.value)
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            loadGenerateScheduledBilling({
              variables: {
                CompanyID,
                isBilled: listStatus === 'BILLED' ? true : false,
                take: 30,
                skip: 0,
                searchValue:
                  getSearch?.name !== '' || getSearch?.name === undefined
                    ? undefined
                    : getSearch?.name,
              },
            })
            localStorage.removeItem('searchFilter')
          }}
        />
      </div>

      <ARGenerateScheduledBillingEntryList
        filteredList={filteredList}
        ScheduledBillingbyStatusLoading={
          getGenerateScheduledBillingListingLoading
        }
        listStatus={listStatus}
        userList={getUsersByAccountAndSoftware}
        fetchMore={loadGenerateScheduledBilling}
        setOriginalListing={setOriginalListing}
        errMessage={errMessage}
        setErrMessage={setErrMessage}
        errDialog={errDialog}
        setErrDialog={setErrDialog}
        postIDs={postIDs}
        setPostIDs={setPostIDs}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-receivable/${CompanyID}`)
        }}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
